import { useQuery } from "react-query"
import { useEffect, useState } from "react"
import ImvCard from "../components/ImvCard"
import GetImvs from "../services/GetImvs"
import FaiNavbar from "../components/Navbar"
import LoadingWheel from "../components/assets/LoadingWheel"
import { ImvCardModal } from "../components/[modal]ImvCard"
import { Transition } from "@headlessui/react"
import { FiltersBar } from "../components/_filtersBar"
import { FiltersDrawer } from "../components/Home/_filtersDrawer"


export default function PageImvSearch() {
    const [isCardOpen, setIsCardOpen] = useState(false)
    const [selectedCard, setSelectedCard] = useState(null)

    const [isDrawerOpen, setIsDrawerOpen] = useState(false)

    const urlParams = new URLSearchParams(window.location.search)
    const filtersEncoded = urlParams.get('filters')
    const filters = decodeURIComponent(filtersEncoded)
    const jsonFilters = JSON.parse(filters)

    const applyFilters = () => {

    }

    useEffect(() => {
        console.log(`Local: ${jsonFilters}`);
    }, [filters])


    const local = jsonFilters?.local
    const quartos = jsonFilters?.quartos
    const tipo = jsonFilters?.tipo
    const valor = jsonFilters?.valor


    const handleCardOpen = (imv) => {
        // console.log('Opened: ', imv.nreg)
        setIsCardOpen(true)
        setSelectedCard(imv)
    }
    const onClose = () => {
        setIsCardOpen(false)
        setSelectedCard(null)
    }

    const { data, isLoading, error } = useQuery('imoveis', GetImvs)

    useEffect(() => {
        // console.log('imoveis na pesquisa: ', data)
    }, [data])

    return (<>
        {selectedCard && (
            <Transition appear show={isCardOpen}>
                <Transition.Child
                    as='div'
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                >
                    <ImvCardModal imv={selectedCard} onClose={onClose} isOpen={isCardOpen} />
                </Transition.Child>
            </Transition>
        )}
        {isDrawerOpen && (
            <FiltersDrawer show={isDrawerOpen} setIsDrawerOpen={setIsDrawerOpen} />
        )}
        <section className="w-full min-h-screen bg-[#1d4aa7]">
            <FaiNavbar />

            <article className="overflow-y-scroll">
                <h2 className="text-3xl my-10 text-center text- font-thin"> Resultados da Pesquisa: </h2>

                <FiltersBar filters={jsonFilters} setIsDrawerOpen={setIsDrawerOpen} />

                <div className="w-full min-h-screen h-auto shadow-xl max-sm:flex max-[1000px]:grid-cols-1 bg-gradient-to-b from-[#444e6d6b] rounded-xl to-[#1c386d] max-[1600px]:grid-cols-3 grid flex-col 2xl:grid 2xl:grid-cols-5 gap-10 p-10">
                    {
                        data && data.map((imovel) => (
                            <ImvCard key={imovel.id} imv={imovel}
                                onOpen={handleCardOpen}
                            />
                        ))
                    }
                    {isLoading &&
                        <div className="min-h-full min-w-full col-span-5 flex items-center justify-center">
                            <span className="w-14 aspect-square">
                                <LoadingWheel color='#4179ed' />
                            </span>
                        </div>
                    }
                </div>
            </article>
        </section>
    </>)
}